var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('transition',{attrs:{"leave-active-class":"opacityOut","enter-active-class":"opacityIn","mode":"out-in","appear":""}},[_c('router-view',{ref:"main"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }